import { Nen3140Score } from './Nen3140Score';

export function nen3140ScoreToColorCode(nen3140Score?: Nen3140Score | null) {
    switch (nen3140Score) {
        case 'OK':
            return '#00B050';
        case 'A':
            return '#FF0000';
        case 'B':
            return '#FFC000';
        case 'C':
            return '#FFC000';
        case 'D':
            return '#0070C0';
        case 'E':
            return '#0070C0';
        case 'F':
            return '#0070C0';
        case 'NVT':
            return '#000000';
        default:
            return '#ECECEC'; // '#3bafda';
    }
}
